import { Component } from '@angular/core';
import { Feature } from 'ol';
import { Geometry } from 'ol/geom.js';
import * as GeoJSONModule from 'ol/format/GeoJSON.js';
const GeoJSON = GeoJSONModule.default as typeof GeoJSONModule.default;
import { AtlasBaseMapComponent } from './atlas-base-map.component';

@Component({
  standalone: false,
  template: ''
})
export abstract class AtlasClickResultComponent extends AtlasBaseMapComponent {
  protected renderSingleResponse(
    result: { fc: any; layer?: any } | null,
    onClear: () => void,
    onResult: (features: Feature<Geometry>[], layer?: any) => void,
    onEmpty?: () => void
  ): void {
    if (!result || !result.fc) {
      onEmpty?.();
      return;
    }

    const features = new GeoJSON().readFeatures(result.fc) as Feature<Geometry>[];
    if (!features.length) {
      onEmpty?.();
      return;
    }

    onClear();
    onResult(features, result.layer);
  }

  protected renderMultipleResponses(
    featureCollections: any[],
    onClear: () => void,
    onResult: (features: Feature<Geometry>[]) => void
  ): void {
    let cleared = false;
    featureCollections.forEach((featureCollection) => {
      const features = new GeoJSON().readFeatures(featureCollection) as Feature<Geometry>[];
      if (!features.length) return;
      if (!cleared) {
        onClear();
        cleared = true;
      }
      onResult(features);
    });
  }
}